import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { OptimizedPrismicImage } from '@/components';
import { JSX } from 'react';
import styles from './textLine.module.scss';

export type TextLineProps = SliceComponentProps<Content.TextLineSlice>;

const TextLine = ({ slice }: TextLineProps): JSX.Element => {
  const values = Array.from({ length: 10 });

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.wrapper}
      id={slice.id}
    >
      {[0, 1].map((el) => (
        <div key={el} className={styles.content}>
          {values.map((_, index) => (
            <div key={index} className={styles.element}>
              <p className={styles.text}>{slice.primary.text}</p>
              <OptimizedPrismicImage
                field={slice.primary.icon}
                className={styles.image}
              />
            </div>
          ))}
        </div>
      ))}
    </section>
  );
};

export default TextLine;
